import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Modal, Form, Checkbox, Segment, Label, Icon, Button } from 'semantic-ui-react';
import { EditorTagSearch } from '../containers/index';
import { Resource } from './index';
import { resourceType } from '../types';

const propTypes = {
  resource: resourceType.isRequired,
  isNew: PropTypes.bool.isRequired,
  addResource: PropTypes.func.isRequired,
  updateResource: PropTypes.func.isRequired,
  closeResourceEditor: PropTypes.func.isRequired,
};

function tagSort(a, b) {
  if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
  if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
  return 0;
}

class ResourceEditor extends Component {
  componentWillMount() {
    this.resetComponent();
  }

  resetComponent() {
    return this.setState({
      resource: {
        ...this.props.resource,
        tags: this.props.resource.tags.sort(tagSort),
      },
      updatePosting: false,
    });
  }

  pushUpdate(resource) {
    const data = {
      ...resource,
      tags: resource.tags.map(tag => (tag._id)),
    };
    axios.post(`/api/resources/${this.props.isNew ? 'insert-one' : 'update-one'}`, data)
      .then((response) => {
        const resourceWithId = {
          ...resource,
          _id: response.insertedId,
          p: [[0]],
        };
        if (this.props.isNew) this.props.addResource(resourceWithId);
        else this.props.updateResource(resource);
        this.resetComponent();
        this.props.closeResourceEditor();
      })
      .catch((err) => {
        console.log('error', err);
        this.setState({
          updatePosting: false,
        });
      });
  }

  render() {
    const initialResource = this.props.resource;
    const { isNew, closeResourceEditor } = this.props;
    const { resource, updatePosting } = this.state;
    if (!initialResource) return null;
    return (
      <Modal
        closeOnDimmerClick={false}
        open
      >
        <div id="resource-preview">
          <Resource
            resource={{
              ...resource,
              done: true,
            }}
            index={0}
            clientMode
            openResourceEditor={null}
          />
        </div>
        <Modal.Header>{`Edit: ${initialResource.name}`}</Modal.Header>
        <Modal.Content scrolling>
          <Form id="edit-grid">
            <Segment compact className="enabler">
              <Checkbox
                toggle
                id="resDone"
                checked={!!resource.done}
                onChange={() => {
                  this.setState({
                    resource: {
                      ...resource,
                      done: !resource.done,
                    },
                  });
                }}
              />
            </Segment>
            <Form.Field className="resName">
              <Form.Input
                label="Name"
                id="resName"
                type="text"
                defaultValue={resource.name}
              />
            </Form.Field>
            <Form.Field className="resDesc">
              <Form.TextArea
                label="Description"
                id="resDesc"
                type="text"
                defaultValue={resource.description}
                onChange={(event, data) => {
                  this.setState({
                    resource: {
                      ...resource,
                      description: data.value,
                    },
                  });
                }}
              />
            </Form.Field>
            <Form.Field className="resURL">
              <Form.Input
                label="Link URL"
                id="resURL"
                type="url"
                defaultValue={resource.url}
                onChange={(event, data) => {
                  this.setState({
                    resource: {
                      ...resource,
                      url: data.value,
                    },
                  });
                }}
              />
            </Form.Field>
            <Form.Field className="resEmail">
              <Form.Input
                label="Email"
                id="resEmail"
                type="email"
                defaultValue={resource.email}
                onChange={(event, data) => {
                  this.setState({
                    resource: {
                      ...resource,
                      email: data.value,
                    },
                  });
                }}
              />
            </Form.Field>
            <Form.Field className="resPhone">
              <Form.Input
                label="Phone"
                id="resPhone"
                type="text"
                defaultValue={resource.phone}
                onChange={(event, data) => {
                  this.setState({
                    resource: {
                      ...resource,
                      phone: data.value,
                    },
                  });
                }}
              />
            </Form.Field>
            <Form.Field className="resFee">
              <label htmlFor="resFee">Fee</label>
              <Form.Checkbox
                id="resFee"
                defaultChecked={!!resource.fee}
                onChange={(event, data) => {
                  this.setState({
                    resource: {
                      ...resource,
                      fee: data.checked,
                    },
                  });
                }}
              />
            </Form.Field>
            <Form.Field className="resPopulation">
              <Form.Input
                label="For Students"
                id="resPopulation"
                type="text"
                defaultValue={resource.forStudents}
                onChange={(event, data) => {
                  this.setState({
                    resource: {
                      ...resource,
                      forStudents: data.value,
                    },
                  });
                }}
              />
            </Form.Field>
            <Form.Field className="resAddress">
              <Form.TextArea
                label="Address"
                id="resAddress"
                type="text"
                defaultValue={resource.address}
                onChange={(event, data) => {
                  this.setState({
                    resource: {
                      ...resource,
                      address: data.value,
                    },
                  });
                }}
              />
            </Form.Field>
            <Form.Field className="resLocation">
              <Form.Select
                defaultValue={resource.onCampus}
                id="resLocation"
                label="Location"
                options={[
                  { key: 'on', text: 'On Campus', value: 'On Campus' },
                  { key: 'off', text: 'Off Campus', value: 'Off Campus' },
                  { key: 'online', text: 'Online', value: 'Online' },
                ]}
                onChange={(event, data) => {
                  this.setState({
                    resource: {
                      ...resource,
                      onCampus: data.value,
                    },
                  });
                }}
              />
            </Form.Field>
            <Form.Field className="resOffice">
              <Form.Input
                label="BU Office"
                id="resOffice"
                type="text"
                defaultValue={resource.buOffice}
                onChange={(event, data) => {
                  this.setState({
                    resource: {
                      ...resource,
                      buOffice: data.value,
                    },
                  });
                }}
              />
            </Form.Field>
            <Form.Field className="resContact">
              <Form.Input
                label="Contact Name"
                id="resContact"
                type="text"
                defaultValue={resource.contactName}
                onChange={(event, data) => {
                  this.setState({
                    resource: {
                      ...resource,
                      contactName: data.value,
                    },
                  });
                }}
              />
            </Form.Field>
            <Form.Field className="resNonBU">
              <Form.Input
                label="Available to Non-BU"
                id="resNonBU"
                type="text"
                defaultValue={resource['non-BU']}
                onChange={(event, data) => {
                  this.setState({
                    resource: {
                      ...resource,
                      'non-BU': data.value,
                    },
                  });
                }}
              />
            </Form.Field>
            <Form.Field className="resImg">
              <Form.Input
                label="Image Name"
                id="resImg"
                type="text"
                defaultValue={resource.imgName}
                onChange={(event, data) => {
                  this.setState({
                    resource: {
                      ...resource,
                      imgName: data.value,
                    },
                  });
                }}
              />
            </Form.Field>
            <Segment.Group className="tagsAdded">
              <Segment>
                <Label attached="top">Tags</Label>
              </Segment>
              <Segment>
                <EditorTagSearch
                  selectedTags={resource.tags.map(tag => tag._id)}
                  onSelection={(data) => {
                    this.setState({
                      resource: {
                        ...resource,
                        tags: [
                          ...this.state.resource.tags,
                          {
                            _id: data.key,
                            name: data.title,
                          },
                        ].sort(tagSort),
                      },
                      searchValue: '',
                    });
                  }}
                />
              </Segment>
              <Segment className="tagContainer">
                {resource.tags.map(tag => (
                  <Label key={tag._id} color="teal">
                    {tag.name}
                    <Icon
                      name="delete"
                      onClick={() => {
                        this.setState({
                          resource: {
                            ...resource,
                            tags: resource.tags.filter(t => t._id !== tag._id),
                          },
                        });
                      }}
                    />
                  </Label>
                ))}
              </Segment>
            </Segment.Group>
            <Form.Field className="resNotes">
              <Form.TextArea
                label="notes"
                defaultValue={resource.notes}
                onChange={(event, data) => {
                  this.setState({
                    resource: {
                      ...resource,
                      notes: data.value,
                    },
                  });
                }}
              />
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="red"
            content="Cancel"
            icon="cancel"
            labelPosition="right"
            onClick={() => {
              this.setState({
                resource: this.props.resource,
              });
              closeResourceEditor();
            }}
          />
          <Button
            primary
            loading={updatePosting}
            content={isNew ? 'Create' : 'Update'}
            icon="save"
            labelPosition="right"
            onClick={() => {
              this.setState({ updatePosting: true });
              this.pushUpdate({
                ...resource,
                name: document.getElementById('resName').value,
              });
            }}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

ResourceEditor.propTypes = propTypes;

export default ResourceEditor;



// WEBPACK FOOTER //
// ./src/components/ResourceEditor.jsx